b247.adblock = function() {

  if (document.getElementById('IFFIHSsLlgmiNRFccBpu')) {

    //alert('Blocking Ads: No');

  } else {

    if (!Cookies.get('has_seen_adblock_message')) {

      Cookies.set('has_seen_adblock_message', 'yes', { expires: 1 });

      var page_top = b247.window.scrollTop();
      b247.body.css('margin-top', '-' + page_top + 'px');
      b247.html.addClass('html--overlay-open');

      b247.body.append(
      '<div class="overlay" style="display:block;" data-overlay="adblock">' +
        '<div class="overlay__inner">' +
          '<div class="overlay__inner__inner">' +
            '<div class="overlay__inner__inner__inner">' +
              '<div class="cms">' +
                '<p class="alpha">Adblocker Detected</p>' +
                '<p>We notice you have an adblocker active. Bristol24/7 is a community interest company, which means that all of the profits that we make go back into our publication so that we can better serve our audience with impartial content that is relevant to you.</p>' +
                '<p>The majority of our advertisers are small local businesses, with products and services that benefit our great city. We want to keep Bristol24/7 free to read for all of our audiences online and in print, so please do consider turning off your adblocker to support our work. Thank you!</p>' +
                '<p><a href="#" class="button button--white" data-overlay-close>Continue</a></p>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>');

      $('[data-overlay="adblock"] [data-overlay-close]').click(function() {

        b247.html.removeClass('html--overlay-open');
        b247.body.css('margin-top', 0);
        $('html, body').scrollTop(page_top);
        $('[data-overlay="adblock"]').remove();
        return false;

      });

    }

  }

};
